import Info from './Info';
import PaymentButton from './PaymentButton';
import { GoQuestion } from 'react-icons/go';
import { FiLink } from 'react-icons/fi';
import { IoArrowDownOutline } from 'react-icons/io5';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { Spinner } from 'reactstrap';

const Payment = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const data = JSON.parse(atob(id));

  useEffect(() => {
    document.title = data?.ap;
    if (data?.e < moment().unix()) return navigate('/expire');
  }, [navigate, data?.e, data?.ap]);

  if (!data) {
    return (
      <Spinner
        animation='grow'
        style={{
          height: '5rem',
          width: '5rem'
        }}
      />
    );
  }
  return (
    <div className='Payment-page'>
      {/* nav bar */}
      <nav className='payment-nav'>
        <h5>Payment</h5>
      </nav>

      {/* Payment Content */}
      <div className='payment-content'>
        {/* Order Close div */}
        <div className='order-close'>
          <p style={{ fontSize: '15px' }}>Order will be closed in:</p>
          {/* time div */}
          <CountDown />
        </div>

        {/* USer info  Div */}

        <Info text={`₹ ${data.a}`} title='Amount' />
        <Info text={`${data.up}`} title='VPA/UPI' />

        <hr id='divider' />

        {/* PAyment Methods Content */}
        <div className='transfer-money'>
          <GoQuestion size='15px' color='#06BBF3' />
          <p
            style={{
              paddingTop: '13px',
              color: '#06BBF3',
              paddingBottom: '12px',
              fontSize: '14px'
            }}
          >
            How to transfer money
          </p>
          <FiLink size='13px' color='#06BBF3' />
        </div>

        {/* Option 1 */}
        <div className='option1'>
          <PaymentButton path='/images/phonepay.png' name='phonepay' />
          <PaymentButton path='/images/paytmm.png' name='paytm' />
        </div>
        <div className='option2'>
          <PaymentButton path='/images/googlePay.png' name='googlepay' />
          <PaymentButton path='/images/upiLogo.png' name='upipay' />
        </div>

        {/* UTR Info */}
        <div className='fillutr-div'>
          <IoArrowDownOutline size='15px' color='#06BBF3' />
          <p
            style={{
              paddingTop: '10px',
              color: '#06BBF3',
              paddingBottom: '12px',
              textAlign: 'start',
              fontSize: '14px'
            }}
          >
            Fill the UTR numbers after you done payment
          </p>
        </div>

        {/* UTR Option */}
        <div className='utr-div'>
          <p style={{ fontSize: '15px' }}>UTR</p>
          <input placeholder='Input UTR number' />
        </div>

        {/* Submit button */}
        <button
          style={{
            width: '100%',
            color: 'white',
            background: '#1989F9',
            border: 'none',
            borderRadius: '50px',
            paddingTop: '8px',
            paddingBottom: '8px'
          }}
        >
          Submit UTR
        </button>

        {/* Notice */}
        <div className='notice-div'>
          <p
            style={{
              color: 'red',
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px'
            }}
          >
            Notice:
          </p>
          <p>
            1.<span style={{ color: 'red' }}> One UPI </span> can only transfer
            money <span style={{ color: 'red' }}>once</span>.
          </p>
          <p>
            2. Don't change the{' '}
            <span style={{ color: 'red' }}>payment method</span>.Otherwise, the
            order cannot be closed
          </p>
        </div>

        {/* Payment Comp logos */}

        <div className='logo-div'>
          <img
            style={{ height: '50px' }}
            src='/images/phonepayLogo.png'
            alt='phonepayLogo'
          />
          <img
            style={{ height: '26px' }}
            src='/images/googlepayLogo.png'
            alt='googlepayLogo'
          />
          <img
            style={{ height: '50px' }}
            src='/images/paytmupiLogo.png'
            alt='paytmupiLogo'
          />
          <img
            style={{ height: '20px' }}
            src='/images/upi.png'
            alt='phonepayLogo'
          />
        </div>

        <p style={{ fontSize: '9px', color: 'lightgrey', textAlign: 'start' }}>
          Dear customers: Please give priority to this channel to recharge!
          Support UPI account withdrawl! ICIC Bank gurantee! Safe and reliable!
        </p>
      </div>
    </div>
  );
};

export default Payment;

const CountDown = () => {
  const [minutes, setMinutes] = useState(10);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (minutes === 0 && seconds === 0) return; // stop when finished

    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [minutes, seconds]);
  
  return (
    <div className='time-div'>
      <div className='time'>
        <p
          style={{
            color: 'white',
            fontSize: '14px',
            fontWeight: 'normal'
          }}
        >
          {minutes}
        </p>
      </div>
      <p style={{ color: '#1989F9', fontWeight: 'normal' }}>:</p>
      <div className='time'>
        <p
          style={{
            color: 'white',
            fontSize: '14px',
            fontWeight: 'normal'
          }}
        >
          {seconds}
        </p>
      </div>
    </div>
  );
};
